<template>
  <div
    :class="{ selected: auctionBatch.lote.loteId === selectedBatch }"
    class="row p-3 mt-2 shadow-sm bg-white"
  >
    <div class="col-11">
      <div class="row">
        <div class="col-2 text-center text-primary">
          <div
            data-cy="file-number"
            v-tooltip="'Folio Lote'"
            :class="{ 'text-success': wasCopied }"
            class="cursor-pointer"
            @click="copyToClipboard(auctionBatch.lote.loteId, auctionBatch.lote.folio)"
          >
            {{ auctionBatch.lote.folio }}
          </div>
        </div>
        <div class="col-2">
          <vs-chip
            :color="batchesStates[auctionBatch.lote.estado].color"
            v-if="batchesStates[auctionBatch.lote.estado]"
            v-tooltip="`${batchesStates[auctionBatch.lote.estado].label}`"
          >
            {{batchesStates[auctionBatch.lote.estado].label}}
          </vs-chip>
        </div>
        <div class="col-8">
          <div class="row">
            <div class="col-4">
              {{ auctionBatch.lote.loteadoraValor || '-' }}
            </div>
            <div class="col-2">
              <span v-if="auctionBatch.lote.requiereVb === 0">
                No
              </span>
              <span v-if="auctionBatch.lote.requiereVb === 1">
                Si
              </span>
            </div>
            <div class="col-2">
              <span v-if="auctionBatch.lote.esExLote === IS_EXISTING_BATCH">
                Si
              </span>
              <span v-if="auctionBatch.lote.esExLote === IS_NOT_EXISTING_BATCH">
                No
              </span>
            </div>
            <div class="col-3">
              {{ auctionBatch.lote.calidadJuridicaNombre || '-'}}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-11 offset-1">
          <vs-chip
            class="mr-4"
            color="#7d84ad"
            v-tooltip="'Monto Mínimo'"
            v-if="auctionBatch.lote.montoMinimo"
          >
            <vs-avatar icon="monetization_on" />
            {{ auctionBatch.lote.montoMinimo | amount}}
          </vs-chip>
          <vs-chip color="#ff9800" class="mr-4" v-tooltip="'Fecha de Emisión'">
            <vs-avatar icon="date_range" />
            {{ auctionBatch.lote.fechaCreacion | dateFormat}}
          </vs-chip>
          <vs-chip color="primary" class="mr-4" v-tooltip="'Usuario Creador'">
            <vs-avatar icon="person" />
            {{ auctionBatch.lote.usuario.alias || '-'}}
          </vs-chip>
          <vs-chip
            class="mr-4"
            color="#7d84ad"
            v-tooltip="'Subasta Asociada'"
            v-if="auctionBatch.subasta"
          >
            <vs-avatar icon="gavel" />
            {{ auctionBatch.subasta.folio }}
          </vs-chip>
          <vs-chip
            class="mr-4"
            color="primary"
            v-tooltip="'Posición Subasta'"
            v-if="showPositionInfo"
          >
            <vs-avatar icon="location_on" />
            {{
              `${auctionBatch.lote.loteadora.codigo}
              -${auctionBatch.subasta.gestora.codigoAduana}
              -${auctionBatch.lote.folio}
              -${auctionBatch.lote.posicion}`
            }}
          </vs-chip>
          <vs-chip
            v-if="auctionBatch.lote.devolucionesCantidad > 0"
            class="mr-4"
            color="#7d84ad"
            v-tooltip="'Número de devoluciones'"
          >
            <vs-avatar icon="replay" />
            {{auctionBatch.lote.devolucionesCantidad}}
          </vs-chip>
        </div>
      </div>
    </div>
    <div class="col-1 d-flex justify-center">
      <slot name="actions" v-bind:auctionBatch="auctionBatch">
        <AuctionHistoryOptions
          :ref="'file-options-' + auctionBatch.lote.loteId"
          :auctionBatch="auctionBatch.lote"
          :select-batch="selectBatch"
          v-on:reload-list="handleReloadList"
        />
      </slot>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import AuctionHistoryOptions from '@/febos/aduanas/auctions/views/components/AuctionHistoryOptions';
import CopyToClipboard from '@/febos/chile/approvals/mixins/CopyToClipboard';
import { batchesStates, IS_EXISTING_BATCH, IS_NOT_EXISTING_BATCH } from '@/febos/aduanas/batches/views/utils/constants';

export default {
  components: { AuctionHistoryOptions },
  mixins: [CopyToClipboard],
  data() {
    return {
      batchesStates,
      IS_EXISTING_BATCH,
      IS_NOT_EXISTING_BATCH
    };
  },
  props: [
    'selectBatch',
    'auctionBatch'
  ],
  computed: {
    ...mapGetters('batches', ['selectedBatch']),
    showPositionInfo() {
      return (this.auctionBatch.lote.posicion
        && this.auctionBatch.subasta
        && this.auctionBatch.subasta.gestora
        && this.auctionBatch.lote.loteadora.codigo);
    },
  },
  methods: {
    handleReloadList() {
      this.$emit('reload-list');
    }
  }
};
</script>
<style>
.selected {
  background: rgba(var(--vs-primary), 0.1) !important;
}
</style>
